function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M22,1.333L6,1.333C4.533,1.333 3.333,2.533 3.333,4L3.333,22.667L6,22.667L6,4L22,4L22,1.333ZM26,6.667L11.333,6.667C9.866,6.667 8.666,7.867 8.666,9.334L8.666,28.001C8.666,29.468 9.866,30.668 11.333,30.668L26,30.668C27.467,30.668 28.667,29.468 28.667,28.001L28.667,9.334C28.667,7.867 27.467,6.667 26,6.667ZM26,28L11.333,28L11.333,9.333L26,9.333L26,28Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.59e33b8c503ca98b5c98705ca13b367d.svg";
export { ForwardRef as ReactComponent };